
export type IconProps = { 
  size?: number; 
  strokeW?: number; 
};

export const SplitIcon: React.FC<IconProps> = ({ size = 18, strokeW = 2.2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2.5" y="4.5" width="19" height="15" rx="3.5" stroke="white" strokeWidth={strokeW} />
    <line x1="12" y1="4.5" x2="12" y2="19.5" stroke="white" strokeWidth={strokeW + 0.6} strokeLinecap="round" />
  </svg>
);

export const UnsplitIcon: React.FC<IconProps> = ({ size = 18, strokeW = 2.2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2.5" y="4.5" width="19" height="15" rx="3.5" stroke="white" strokeWidth={strokeW} />
  </svg>
);
